import api from ".";

export default api;
